export const logEvent = (event, properties) => {
	const obj = {'event': event, ...properties};

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(obj);
	
	console.log("GTM : logEvent",obj);
}

export const logData = (data) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(data);
	
	console.log("GTM : logEvent",data);
}